<template>
  <div
    class="group relative map-marker-pulse-target"
    :style="{ '--marker-color': color }"
  >
    <div
      class="relative z-10 size-10 rounded-full flex"
      :style="{ background: color + '50' }"
    >
      <div class="size-4 rounded-full m-auto" :style="{ background: color }" />
    </div>
  </div>
</template>
<script setup>
defineProps({
  markerClass: {
    type: String,
    default: 'text-primary',
  },
  color: {
    type: String,
    default: '#4156cf',
  },
  target: {
    type: Number,
    default: null,
  },
  id: {
    type: Number,
    default: null,
  },
})
</script>

<style scoped>
.map-marker-pulse-target.map-pulse-active::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 9999px;
  background: var(--marker-color);
  opacity: 0.45;
  animation: markerPulse 1.25s cubic-bezier(0, 0, 0.2, 1) infinite;
}

@keyframes markerPulse {
  75%,
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
</style>
